export type DictionarySlugEntry = {
  id: number
  simplified: string
  pinyin: string
}

const HAN_LETTER_OR_NUMBER = /[\p{Script=Han}\p{Letter}\p{Number}]+/gu

function stripToneMarks(value: string) {
  return value
    .replace(/ü/g, 'u')
    .replace(/Ü/g, 'u')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
}

function slugPart(value: string, fallback: string) {
  const normalized = stripToneMarks(value)
    .toLowerCase()
    .match(HAN_LETTER_OR_NUMBER)
    ?.join('-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')

  return normalized || fallback
}

export function generateDictionarySlug(entry: DictionarySlugEntry) {
  return [
    slugPart(entry.simplified, 'entry'),
    slugPart(entry.pinyin, 'word'),
    entry.id
  ].join('-')
}

export function parseDictionarySlug(slug: string) {
  const decoded = decodeURIComponent(slug)
  const match = decoded.match(/-(\d+)$/)
  if (!match) return null

  const id = Number(match[1])
  return Number.isSafeInteger(id) && id > 0 ? { id } : null
}

export function isCanonicalDictionarySlug(
  slug: string,
  entry: DictionarySlugEntry
) {
  return decodeURIComponent(slug) === generateDictionarySlug(entry)
}

export function getDictionaryEntryPath(entry: DictionarySlugEntry) {
  return `/dict/${generateDictionarySlug(entry)}`
}
